
// // STICKY BAR BUY NOW - JS CODE

// $(window).scroll(function () {
//     const collection = document.getElementsByClassName("sticky-bar-form");
//     for (let element of collection) {
//         if (!element.classList.contains('custom-sticky-bar')) {
//             element.remove();
//         }
//     }
//     // Check the scroll position from the top
//     if ($(window).scrollTop() >= 300) {
//         $('.sticky-bar').css('display', 'flex');
//         $('.sticky-bar').css('position', 'fixed');

//     } else {
//         // Hide the sticky bar when scrolled less than 300px
//         $('.sticky-bar').css('display', 'none');
//         $('.sticky-bar').css('position', 'fixed');

//     }
// });

// let movedStickyEleToOuterEle = false
// $(document).ready(function () {
//     $(window).scroll(function () {
//         const mainContentEle = document.getElementById('MainContent');
//         if (mainContentEle) {
//             if (!movedStickyEleToOuterEle) {
//                 movedStickyEleToOuterEle = true;
//                 const collection = document.getElementsByClassName("sticky-bar-form");
//                 if (collection.length > 0) {
//                     const elementToMove = collection[0];
//                     elementToMove.classList.add("custom-sticky-bar");
//                     mainContentEle.appendChild(elementToMove);
//                 }
//             }
//         }
//     })
// });
// STICKY BAR BUY NOW - JS CODE (Vanilla JS, no jQuery)

window.addEventListener('scroll', function () {
    const collection = document.getElementsByClassName("sticky-bar-form");
    for (let element of collection) {
        if (!element.classList.contains('custom-sticky-bar')) {
            element.remove();
        }
    }

    const stickyBar = document.querySelector('.sticky-bar');
    if (stickyBar) {
        // Check the scroll position from the top
        if (window.scrollY >= 300) {
            stickyBar.style.display = 'flex';
            stickyBar.style.position = 'fixed';
        } else {
            // Hide the sticky bar when scrolled less than 300px
            stickyBar.style.display = 'none';
            stickyBar.style.position = 'fixed';
        }
    }
});

let movedStickyEleToOuterEle = false;

document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', function () {
        const mainContentEle = document.getElementById('MainContent');
        if (mainContentEle) {
            if (!movedStickyEleToOuterEle) {
                movedStickyEleToOuterEle = true;
                const collection = document.getElementsByClassName("sticky-bar-form");
                if (collection.length > 0) {
                    const elementToMove = collection[0];
                    elementToMove.classList.add("custom-sticky-bar");
                    mainContentEle.appendChild(elementToMove);
                }
            }
        }
    });
});